import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Grid, TextField, FormControl, InputLabel, Select, MenuItem, Autocomplete } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { axiosInstance, localAxiosGet, localAxiosPut, localAxiosToken } from '../../../Axios/axios';
import { Snackbar, Alert } from '@mui/material';
import axios from 'axios';

const textFieldStyles = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#3b82f6',
        },
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#3b82f6',
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: '#3b82f6',
    },
};

const EditTaskDetails = ({ selectedTask, onClose }) => {

    const [editedDetails, setEditedDetails] = useState({
        task_title: selectedTask?.task_title || '',
        start_date: selectedTask?.start_date || null,
        due_date: selectedTask?.due_date || null,
        description: selectedTask?.description || '',
        estimated_hours: selectedTask?.estimated_hours || ''
    });
    const [updatedDetails, setUpdateDetails] = useState({})
    const accessToken = localStorage.getItem('accessToken');
    const employeeId = localStorage.getItem('userId');

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
    });


    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setEditedDetails(prevDetails => ({
            ...prevDetails,
            [name]: value,
        }));
    };


    const handleDateChange = (name, date) => {
        setEditedDetails(prevDetails => ({
            ...prevDetails,
            [name]: date,
        }));
    };


    useEffect(() => {
        setEditedDetails({
            task_title: selectedTask?.task_title || '',
            start_date: selectedTask?.start_date || null,
            due_date: selectedTask?.due_date || null,
            description: selectedTask?.description || '',
            estimated_hours: selectedTask?.estimated_hours || ''
        });
    }, [selectedTask]);


    const handleSaveChanges = async () => {
        try {
            const payload = {
                task_title: editedDetails.task_title,
                start_date: editedDetails.start_date
                    ? new Date(editedDetails.start_date).toISOString()
                    : null,
                due_date: editedDetails.due_date
                    ? new Date(editedDetails.due_date).toISOString()
                    : null,
                description: editedDetails.description,
                estimated_hours: parseFloat(editedDetails.estimated_hours) || 0,
            };

            // 1. Update task details
            const response = await axiosInstance(localAxiosPut(`/task/editTask/${selectedTask.task_id}`, payload, accessToken))

            if (response.data.status === 'SUCCESS') {
                setUpdateDetails(response.data.message.task)
                setSnackbar({
                    open: true,
                    message: response.data.message.message || 'Task updated successfully!',
                    severity: 'success',
                });
               
            } else {
                setSnackbar({
                    open: true,
                    message: response.data.message || response.data?.message?.msg ||'Failed to update task.',
                    severity: 'error',
                });  
               }

            if (response.data.status === 'SUCCESS') {
                // 2. Check due date change
                const originalDueDate = selectedTask.due_date
                    ? new Date(selectedTask.due_date).toISOString()
                    : null;
                const newDueDate = payload.due_date;

                if (originalDueDate !== newDueDate) {
                    let newStatus = 'In Progress';
                    const now = new Date();

                    if (new Date(newDueDate) < now) {
                        newStatus = 'Overdue';
                    }

                    if (selectedTask.status === 'Overdue') {
                        newStatus = 'In Progress';
                    }

                    const statusPayload = {
                        employee_id: employeeId,
                        task_id: selectedTask.task_id,
                        status: newStatus,
                    };

                    await axiosInstance(localAxiosToken('/task/updateTaskStatusByManager', statusPayload));

                   
                    setTimeout(() => {
                        onClose();
                    }, 2000);
                }
            }
        } catch (error) {
            setSnackbar({
                open: true,
                message: error.data?.message || error.data?.message?.msg ||'Failed to update task.',
                severity: 'error',
              });
        }
       
    };
    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackbar(prev => ({ ...prev, open: false }));
    };


    return (
        <Box>

            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                mb: 2,
                background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                p: 1,
                borderRadius: '4px',
                color: 'white',
            }}>
                <Edit sx={{ mr: 1, color: 'white', fontSize: 22 }} />
                <Typography variant="h5" component="span" sx={{ fontWeight: 600 }}>
                    Edit Task Details
                </Typography>
            </Box>

            <Box>

                <Grid container spacing={2} marginTop={2}>

                    <Grid item xs={12}>
                        <TextField
                            label="Task Title"
                            fullWidth
                            required
                            name="task_title"
                            value={updatedDetails.task_title || editedDetails.task_title}
                            onChange={handleInputChange}
                            sx={textFieldStyles}
                        />
                    </Grid>


                    <Grid item xs={12} sm={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                label="Start Date"
                                 format='dd/MM/yyyy'
                                value={updatedDetails.start_date || editedDetails.start_date ? new Date(editedDetails.start_date) : null}
                                onChange={(date) => handleDateChange('start_date', date)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        required
                                        sx={textFieldStyles}
                                    />
                                )}
                            />
                        </LocalizationProvider>
                    </Grid>


                    <Grid item xs={12} sm={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                label="End Date"
                                 format="dd/MM/yyyy"
                                value={updatedDetails.due_date || editedDetails.due_date ? new Date(editedDetails.due_date) : null}
                                onChange={(date) => handleDateChange('due_date', date)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        required
                                        sx={textFieldStyles}
                                    />
                                )}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            label="Estimated Hours"
                            type="number"
                            fullWidth
                            name="estimated_hours"
                            value={updatedDetails.estimated_hours || editedDetails.estimated_hours}
                            onChange={handleInputChange}
                            InputProps={{ inputProps: { min: 0 } }}
                            sx={textFieldStyles}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Description"
                            fullWidth
                            multiline
                            rows={3}
                            name="description"
                            value={updatedDetails.description || editedDetails.description}
                            onChange={handleInputChange}
                            sx={textFieldStyles}
                        />
                    </Grid>
                </Grid>
            </Box>

            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', flexShrink: 0 }}>
                <Button variant="outlined" onClick={onClose}>
                    Close
                </Button>
                <Button variant="contained" color="primary" onClick={handleSaveChanges} sx={{ ml: 1 }}>
                    Save
                </Button>
            </Box>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>

        </Box>
    );
};

export default EditTaskDetails;